import * as Sentry from '@sentry/react';

const EXTRA_KEY = 'ROUTE_TO';

const transport = Sentry.makeMultiplexedTransport(
  Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  (args) => {
    const event = args.getEvent();
    if (
      event?.extra &&
      EXTRA_KEY in event.extra &&
      Array.isArray(event.extra[EXTRA_KEY])
    ) {
      const routeTo = event.extra[EXTRA_KEY];
      if (routeTo[0]?.dsn && routeTo[0]?.release) {
        return [{ dsn: routeTo[0].dsn, release: routeTo[0].release }];
      }
    }
    return [];
  }
);

Sentry.init({
  dsn: '__SENTRY_DSN__',
  environment: '__SENTRY_ENVIRONMENT__',
  release: process.env.SENTRY_RELEASE,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.moduleMetadataIntegration(),
  ],
  sampleRate: 0.5,
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  debug: false,
  transport,
  beforeSend: (event) => {
    if (event?.exception?.values?.[0]?.stacktrace?.frames) {
      const { frames } = event.exception.values[0].stacktrace;
      const routeTo = frames
        .filter(
          (frame) =>
            frame.module_metadata?.dsn && frame.module_metadata?.release
        )
        .map((frame) => frame.module_metadata)
        .slice(-1);

      if (routeTo.length) {
        event.extra = {
          ...event.extra,
          [EXTRA_KEY]: routeTo,
        };

        return event;
      }
    }

    return null;
  },
});
